export enum PATHS {
  Introduction = "introduction",
  About = "about-your-household",
  Summary = "summary",
  Submission = "submission",
  OptForPSR = "opt-for-psr",
  PSRServices = "psr-services",
  PSRSummary = "psr-summary",
  PSRSubmission = "psr-submission",
  TemporaryNeeds = "temporary-needs",
}

export enum ABOUT_ROUTES {
  Children = "children",
  Sight = "sight",
  SightDetail = "sight/detail",
  Hearing = "hearing",
  Age = "age",
  AgeDetail = "age/detail",
  AgeCareDetail = "age/care",
  MedicalEquipment = "medical-equipment",
  MedicalEquipmentDetail = "medical-equipment/detail",
  MiscellaneousDetail = "misc",
  ChronicIllness = "chronic-illness",
  ChronicIllnessDetail = "chronic-illness/detail",
  Financial = "financial",
  FinancialDetail = "financial/detail",
  DailyActivity = "daily-activity",
  DailySupport = "daily-activity/support",
}

export const ROUTES_WITH_NO_STEPPER = [
  PATHS.PSRServices,
  PATHS.PSRSummary,
  PATHS.PSRSubmission,
  PATHS.TemporaryNeeds,
];

export const ROUTES = [
  {
    name: "Introduction",
    url: PATHS.Introduction,
  },
  {
    name: "About your household",
    url: PATHS.About,
    routes: ABOUT_ROUTES,
  },
  {
    name: "Summary",
    url: PATHS.Summary,
  },
  {
    name: "Submission",
    url: PATHS.Submission,
  },
  {
    name: "Opt for PSR",
    url: PATHS.OptForPSR,
  },
  {
    name: "Temporary Needs",
    url: PATHS.TemporaryNeeds,
  },
];
